import { useEffect, useRef, useState } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { Loader2, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Brand } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { api, formatErr } from "@/lib/api";

export default function Invite() {
  const { token } = useParams();
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [err, setErr] = useState("");
  const done = useRef(false);
  useEffect(() => {
    if (!user || done.current) return;
    done.current = true;
    api.post(`/invites/${token}/accept`)
      .then(async () => { await refreshUser(); window.location.href = "/dashboard"; })
      .catch((e) => setErr(formatErr(e)));
  }, [user, token, refreshUser, navigate]);
  if (user === false) {
    sessionStorage.setItem("gv_invite", token);
    return <Navigate to="/login?mode=register" replace />;
  }
  return (
    <div className="min-h-screen grid-bg flex flex-col items-center justify-center p-6">
      <div className="mb-10"><Brand /></div>
      <div className="bg-white border border-slate-200 rounded-lg p-10 max-w-md w-full text-center" data-testid="invite-page">
        <Users className="h-10 w-10 text-emerald-600 mx-auto" />
        {err ? <>
          <h1 className="font-display text-2xl font-extrabold mt-6">Couldn't accept invitation</h1>
          <p className="text-slate-600 mt-2 text-sm" data-testid="invite-error">{err}</p>
          <Link to="/dashboard"><Button className="mt-6" variant="outline">Go to dashboard</Button></Link>
        </> : <><Loader2 className="h-6 w-6 animate-spin text-emerald-600 mx-auto mt-6" /><p className="mt-4 text-slate-600">Joining workspace…</p></>}
      </div>
    </div>
  );
}
